import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bg2",
  "use": "icon-bg2-usage",
  "viewBox": "0 0 1205 136",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1205 136\" id=\"icon-bg2\">\r\n  <g transform=\"matrix(1 0 0 1 5 -2065 )\">\r\n    <path d=\"M 984.083333333333 0  C 1069.80798553144 0  1153.56255533992 30.6608428594283  1205 46  L 1205 135  L 0 135  L 0 136  L 0.981896194055161 135.788233430668  C 0.386936144403299 126.634555452302  50.0198103103842 74.9833308244099  194.127712854758 70  C 425.471619365609 62  475.84389971493 105.048536167675  615.575959933222 84  C 681.961602671119 74  898.358681135226 0  984.083333333333 0  Z \" fill-rule=\"nonzero\" fill=\"#edf8ff\" stroke=\"none\" transform=\"matrix(1 0 0 1 -5 2065 )\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bg2.svg
// module id = 1Qfj
// module chunks = 0